// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__JCvnC","slideIn":"Menu_slideIn__EFfcO","content":"Menu_content__KSGhv"};